"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNetwork = exports.createNetworkRandomEndpoint = exports.getChainIdForNetwork = void 0;
const eosjs_1 = require("eosjs");
// @ts-ignore
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const _types_1 = require("./@types");
exports.getChainIdForNetwork = (networkName) => {
    switch (networkName) {
        case `eos`: {
            return `aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906`;
        }
        case `kylin`: {
            return `5fff1dae8dc8e2fc4d5b23b2c7665c97f9e9d8edf2b6485a86ba311c25639191`;
        }
        case `jungle`: {
            return `e70aaab8997e1dfce58fbfac80cbbb8fecec7b99cf982a9444273cbc64c41473`;
        }
        case `wax`: {
            return `1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4`;
        }
        default:
            throw new Error(`Unknown network "${networkName}"`);
    }
};
// TODO: use something like eos-endpoints to always get a low latency once
const getDefaultHttpEndpoint = (networkName) => {
    switch (networkName) {
        case `eos`: {
            return `https://eos.greymass.com:443`;
        }
        case `kylin`: {
            return `https://kylin-dsp-2.liquidapps.io:443`;
        }
        case `jungle`: {
            return `https://jungle2.cryptolions.io:443`;
        }
        case `wax`: {
            return `https://chain.wax.io:443`;
        }
        case `waxtest`: {
            return `https://waxtestnet.greymass.com:443`;
        }
        default:
            throw new Error(`Unknown network "${networkName}"`);
    }
};
exports.createNetworkRandomEndpoint = (networkName, options) => {
    const endpoint = getDefaultHttpEndpoint(networkName);
    return exports.createNetwork(networkName, endpoint, options);
};
exports.createNetwork = (networkNameOrChainId, nodeEndpoint, options = {}) => {
    let chainId = networkNameOrChainId;
    let networkName;
    if (_types_1.isNetworkName(networkNameOrChainId)) {
        networkName = networkNameOrChainId;
        chainId = exports.getChainIdForNetwork(networkNameOrChainId);
    }
    const mergedOptions = Object.assign({ fetch: isomorphic_fetch_1.default }, options);
    const matches = /^(https?):\/\/(.+?)(:\d+){0,1}$/.exec(nodeEndpoint);
    if (!matches) {
        throw new Error(`Could not parse EOS HTTP endpoint. Needs protocol and port: "${nodeEndpoint}"`);
    }
    const [, httpProtocol, host, portMatch] = matches;
    const portString = portMatch
        ? portMatch.replace(/\D/gi, ``)
        : httpProtocol === `https`
            ? `443`
            : `80`;
    const port = Number.parseInt(portString, 10);
    const rpc = new eosjs_1.JsonRpc(nodeEndpoint, mergedOptions);
    return {
        networkName,
        chainId,
        protocol: httpProtocol,
        host,
        port,
        nodeEndpoint,
        rpc,
    };
};
